/* src/app/private/components/temp-student-profile/student-overview/student-overview.component.scss */
/*# sourceMappingURL=student-overview.component.css.map */
